import { IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";
import { deepPurpleMui } from "@ryde/theme";

import {
  useReportChartData,
  useReportChartDrawer,
} from "../drawers/report-chart-drawer";

export const ReportTableHeadChartButton: FC = () => {
  const { t } = useTranslation();
  const { openReportChartDrawer } = useReportChartDrawer();
  const { isChartButtonVisible, hasChartCapability } = useReportChartData();

  if (!isChartButtonVisible) {
    return null;
  }

  return (
    <div data-e2e="report-open-chart-drawer">
      <IconButton
        onClick={openReportChartDrawer}
        disabled={!hasChartCapability}
        className="report_action_button"
        sx={{ cursor: hasChartCapability ? "pointer" : "default" }}
      >
        <FramerTooltip
          content={t("reports.chart.OPEN_CHART")}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <SVG_MUI.ChartBarSVG
            fill={deepPurpleMui.A700}
            className="pointer open-chart-icon"
          />
        </FramerTooltip>
      </IconButton>
    </div>
  );
};
